export default "__VITE_ASSET__DX_j2vn1__"